<template>
  <div class="image-ads">
    <van-image lazy-load :src="item" v-for="(item, i) in list" :key="i" @click="$emit('on-item-click', i)" />
  </div>
</template>

<script>
export default {
  name: 'AdPanel',
  props: {
    list: Array
  }
}
</script>

<style lang="less" scoped>
.image-ads {
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
  }
}
</style>
